import ActionButton, { ActionButtonProps } from "@able/react/dist/ActionButton"
import DropdownMenuExample from "../DataActions/DropdownMenu.helper"
import Pill, { PillProps } from "../Pill"
import PopoverMultiselect, { PopoverMultiSelectProps } from "../PopoverMultiselect"

const getFilterActionComponent = (developmentUrl: string, parent: string) => {
    const CF = ({ type, props }: any) => {
        if (type === 'Pill') {
            return <Pill {...props as PillProps} variant="compact" type="Suggestion" developmentUrl={developmentUrl} />
        }
        else if (type === 'PopoverMultiSelect') {
            return <PopoverMultiselect {...props as PopoverMultiSelectProps} variant={parent === 'action' ? "LowEmphasisCompact" : "MediumEmphasisCompact"} developmentUrl={developmentUrl} />
        }
        else if (type === 'DropdownMenu' && parent === 'action') {
            return <DropdownMenuExample {...props} developmentUrl={developmentUrl} />
        }
        else if (type === 'ActionButton') {
            return <ActionButton {...props as ActionButtonProps} element="button" variant="MediumEmphasisCompact" developmentUrl={developmentUrl} />
        }
        return null
    }

    CF.displayName = "CF";

    return CF;
}

export default getFilterActionComponent